exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-unread[data-v-10eb26c6]{display:block;position:absolute;background-color:#ff2c5d;border-radius:50%}.icon-unread.vertical-center[data-v-10eb26c6]{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", ""]);

